module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure"
    }
  }, [_c('p', {
    staticClass: "structure"
  }, [_vm._v("{~?~begin epigraph}")]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epaft"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("It is evident that the opening lines of “Go Down, Moses,”")]), _vm._v(" "), _c('p', {
    staticClass: "epaft"
  }, [_vm._v("Go down, Moses,")]), _vm._v(" "), _c('p', {
    staticClass: "epaft"
  }, [_vm._v("’Way down in Egypt land;’")]), _vm._v(" "), _c('p', {
    staticClass: "epaft"
  }, [_vm._v("Tell old Pharaoh,")]), _vm._v(" "), _c('p', {
    staticClass: "epaft"
  }, [_vm._v("Let my people go.")]), _vm._v(" "), _c('p', {
    staticClass: "epaft"
  }, [_vm._v("have a significance beyond the bondage of Israel in Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("–James Weldon Johnson, "), _c('i', [_vm._v("The Book of American Negro Poetry")]), _vm._v(", 1922")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c6b2aa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Marbury-0006.vue
// module id = 69
// module chunks = 0